
import {_unloadAll} from "../../jsCom/goForm/components/Common_Fun";
import {GoingUtils,AssertUtils} from "goingutils";
import EditorTypeUtils from "../../common/editorTypeUtils";

let _initQueryCtl = function (queryCtl, elObj) {
    //如果还未初始化下拉 则初始化下拉，再进行展示
    if (!queryCtl.initBody) {
        queryCtl.initQuerySelDrop();
    }
    let {x, y} = GoingUtils.getElementPosition(elObj);

    $("#" + queryCtl.ctlId + "_items")
        .css("zIndex", GoingUtils.getCurMaxZIndex())
        .show()
        .css("left", x - 10)
        .css("top", y + 28);
};

export default class GoSingleQueryCtl {

    constructor(parentId, fieldAry, vueObj, searchFun) {
        this.searchFun = searchFun;
        this.vueObj = vueObj;
        this.parentId = parentId;
        this.initBody = false;
        this.fieldAry = fieldAry;
        this.inputWidth = 120;
        this.curSelItem = null;
        this.prefixCls = GoingUtils.getUUid(12).substring(0, 11);
        this.initCtlDiv();
        //如果用户设置了defQueryItem则 需要初始化控件 并选择第一项
        if (AssertUtils.isNotNull(this.defQueryItem)) {
            let elObj = $(`#${this.ctlId}`).get(0);
            //初始化查询控件
            _initQueryCtl(this, elObj);
            $($("#" + this.ctlId + "_items .search-item").get(0)).click();
        }
    }

    //初始化容器
    initCtlDiv() {
        this.ctlId = GoingUtils.getUUid(12);
        this.fieldConfig = {};
        this.curCtlObj = {};
        $(`<div class="search-box circle pull-left">
            <div class="flex-div clearfix">
                 <div id="${
            this.ctlId
            }" class="search-select pull-left"><div>--查询条件--</div></div>
                 <div id="${
            this.ctlId
            }_down_icon" class="pull-left"><a class="search-button"><i  class="ivu-icon ivu-icon-md-arrow-dropdown"></i></a></div>
                 <div class="search-input clearfix pull-left" id="${
            this.ctlId
            }_input"></div>
                <div id="${
            this.ctlId
            }_btn" class="pull-left"><a class="search-button"><i class="ivu-icon ivu-icon-ios-search"></i></a></div>
            </div>  
      </div>`).appendTo($("#" + this.parentId));

        $(
            `<div id="${
                this.ctlId
                }_items" style="display: none" class="search-items"></div>`
        ).appendTo($("#main_router_view"));
        this.initEvent();

        let queryCtl = this;
        //判断用户是否设置默认选择项
        this.fieldAry.forEach(function (item) {
            if (item["defQuery"]) {
                queryCtl.defQueryItem = item;
            }
        });
    }

    //初始化查询选择区域内容
    initEvent() {
        let queryCtl = this;
        //鼠标移入查询区域
        $(`#${this.ctlId}`).mouseover(function () {
            $("#" + queryCtl.ctlId + "_items").attr("flag", "show");
            let elObj = $(`#${queryCtl.ctlId}`).get(0);
            //初始化查询控件
            _initQueryCtl(queryCtl, elObj);
        });

        //鼠标移出查询控件区域
        $(`#${this.ctlId}`).mouseleave(function () {
            $("#" + queryCtl.ctlId + "_items").attr("flag", "hide");
            setTimeout(function () {
                if ($("#" + queryCtl.ctlId + "_items").attr("flag") === "hide") {
                    $("#" + queryCtl.ctlId + "_items").hide();
                }
            }, 100);
        });

        //鼠标移入
        $(`#${this.ctlId}_down_icon`).click(function () {
            let elObj = $(this)
                .prev()
                .get(0);
            //如果还未初始化下拉 则初始化下拉，再进行展示
            _initQueryCtl(queryCtl, elObj);
        });

        //如果点击的不是控件本身 则隐藏
        $(document).click(function (e) {
            let target = $(e.target);
            if (
                !target.is("#" + queryCtl.ctlId) &&
                !target.is("#" + queryCtl.ctlId + " *") &&
                !target.is("#" + queryCtl.ctlId + "_down_icon") &&
                !target.is("#" + queryCtl.ctlId + "_down_icon *")
            ) {
                $("#" + queryCtl.ctlId + "_items").hide();
            }
        });

        //鼠标移入 选择选项区域
        $("#" + queryCtl.ctlId + "_items").mouseover(function () {
            $("#" + queryCtl.ctlId + "_items").attr("flag", "show");
            $(this).show();
        });

        //鼠标移出 条件选项下拉区域
        $("#" + queryCtl.ctlId + "_items").mouseleave(function () {
            $("#" + queryCtl.ctlId + "_items").attr("flag", "hide");
            if ($("#" + queryCtl.ctlId + "_items").attr("flag") === "hide") {
                $("#" + queryCtl.ctlId + "_items").hide();
            }
            // $(this).hide();
        });

        //点击筛选条件区域弹出选项
        $(`#${this.ctlId}`).click(function () {
            //如果还未初始化下拉 则初始化下拉，再进行展示
            if (!queryCtl.initBody) {
                queryCtl.initQuerySelDrop();
            }
            let {x, y} = GoingUtils.getElementPosition($(this).get(0));
            $("#" + queryCtl.ctlId + "_items")
                .show()
                .css("left", x - 10)
                .css("top", y + 28);
        });

        //点击查询按钮
        $(`#${this.ctlId}_btn`).click(function () {
            if (AssertUtils.isNotNull(queryCtl.curSelItem)) {
                let backJson = {};
                EditorTypeUtils.getSubmitDataByItem(
                    queryCtl.curSelItem,
                    backJson,
                    "singleQuery",
                    queryCtl
                );
                queryCtl.vueObj.$emit("searchFun", backJson);
                if (AssertUtils.isNotNull(queryCtl.searchFun)) {
                    queryCtl.searchFun({datas: backJson});
                }
            }
        });
    }

    //初始化查询选择区域内容
    initQuerySelDrop() {
        this.initBody = true;
        let queryCtl = this;
        let bodyHtmls = [];
        let moreCtl = this;
        this.fieldAry.forEach(function (item) {
            if (item.query != false) {
                queryCtl.fieldConfig[item["id"]] = item;
                bodyHtmls.push(moreCtl.getItemHtml(item));
            }
        });
        $(bodyHtmls.join("")).appendTo($(`#${this.ctlId}_items`));

        //点击选择相应的字段
        $("#" + this.ctlId + "_items .search-item").click(function () {
            //销毁以前定义的相关控件
            queryCtl.destroyPreCtl();
            //选中相应的字段
            queryCtl.setItemSel(this);

            //初始化输入框控件
            queryCtl.initSearchInput(queryCtl.getItemConfig(this));
            $("#" + queryCtl.ctlId + "_items").hide();
        });
    }

    //根据选择的字段 获取该字段对应的配置信息
    getItemConfig(elObj) {
        let fieldId = $(elObj).attr("fieldId");
        return this.fieldConfig[fieldId];
    }

    /**
     * 设置某个字段为选中状态
     * @param elObj
     */
    setItemSel(elObj) {
        let queryCtl = this;
        $("#" + queryCtl.ctlId + "_items .active-item").removeClass("active-item");
        $(elObj).addClass("active-item");

        let itemConfig = this.getItemConfig(elObj);
        //设置当前选中的item
        queryCtl.curSelItem = itemConfig;
        $(`#${queryCtl.ctlId}`).html(itemConfig["label"]);
    }

    //销毁上次初始化的控件
    destroyPreCtl() {
        let queryCtl = this;
        if (queryCtl.curSelItem != null) {
            let inputId = `${queryCtl.prefixCls}_${queryCtl.curSelItem["id"]}`;
            //卸载组件
            if (
                queryCtl[inputId] != null &&
                AssertUtils.isObject(queryCtl[inputId]) &&
                AssertUtils.isFunction(queryCtl[inputId].unload)
            ) {
                queryCtl[inputId].unload();
            }
            //卸载组件的容器
            if (AssertUtils.isFunction(_unloadAll)) {
                _unloadAll(inputId);
            }
        }
    }

    //根据item的配置信息 初始化输入区域
    initSearchInput(itemConfig) {
        //根据编辑类型 获取html代码
        let htmls = this.getHtmlByItem(itemConfig, this);
        $(`#${this.ctlId}_input`).html(htmls);
        //初始化控件的事件
        EditorTypeUtils.initCtlByItemType(
            itemConfig,
            $("#" + this.ctlId + "_input"),
            this.inputWidth,
            this
        );
        //获取焦点
        $(`#${this.ctlId}_input input:eq(0)`).focus();
    }

    //获取选项的html代码
    getHtmlByItem(itemConfig, targetObj) {
        //如果编辑类型为空 则去type作为编辑类型
        if (!AssertUtils.isNotEmpty(itemConfig["editorType"])) {
            itemConfig["editorType"] = itemConfig["type"];
        }
        //如果是switch控件 需要转换下
        if (itemConfig["editorType"] === "switch") {
            itemConfig["items"] = [
                {id: "true", label: "启动"},
                {id: "false", label: "停用"}
            ];
            itemConfig["editorType"] = "staticDrop";
        }

        //如果是radiobox
        if (itemConfig["editorType"] === "radioBox") {
            itemConfig["editorType"] = "staticDrop";
        }
        return EditorTypeUtils.getItemHtmlByType(
            itemConfig,
            "singleQuery",
            targetObj
        );
    }

    //获取选项的html代码
    getItemHtml({id, label}) {
        return ` <div class="search-item" fieldId="${id}">${label}</div>`;
    }
}



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/goSingleQueryCtl.js